import { FC, useCallback } from 'react';
import PriceFilter, { PriceFilterProps } from 'src/search/components/PriceFilter';

type FilterModalPriceProps = Pick<PriceFilterProps, 'values'> & {
  onChange: (val: number[]) => void;
  hasResults: boolean;
};

const FilterModalPrice: FC<FilterModalPriceProps> = ({ onChange, values, hasResults }) => {
  const onChangeMinMax = useCallback((min, max) => onChange([min, max]), [onChange]);
  return (
    <PriceFilter
      searchHasResults={hasResults}
      values={values}
      onChange={onChangeMinMax}
    />
  );
};

export default FilterModalPrice;
